const EMAIL_REGEX = /^\w(?:\.?[\w%'+-]+)*@\w(?:[\w-]*\.)+?[a-z]{2,}$/i;

export function isValidEmail(address: string): boolean {
  return EMAIL_REGEX.test(address.trim());
}
